// react
import React, { useRef } from 'react';
import styled from 'styled-components';

// react-transition-group
import { CSSTransition, SwitchTransition } from 'react-transition-group';

/**
 * LoadingTransition displays a loading state until isLoading is false, then
 * fades into the content.
 */
export const LoadingTransition = ({
  isLoading,
  loading = true,
  content,
  speed = 200,
}: LoadingTransitionProps) => {
  const nodeRef = useRef(null);
  return (
    <SwitchTransition>
      <CSSTransition
        key={isLoading ? 'loading' : 'content'}
        nodeRef={nodeRef}
        timeout={speed * 2}
        classNames='fade'
        unmountOnExit
      >
        <AnimatedOutlet $speed={speed} ref={nodeRef}>
          {isLoading ? loading : content}
        </AnimatedOutlet>
      </CSSTransition>
    </SwitchTransition>
  );
};

interface AnimatedOutletProps {
  $speed: number;
}
const AnimatedOutlet = styled.div<AnimatedOutletProps>`
  display: inherit;
  flex-direction: inherit;
  gap: inherit;
  align-items: inherit;
  justify-content: inherit;

  width: 100%;
  height: 100%;

  &.fade-enter {
    opacity: 0;
  }
  &.fade-enter-active {
    opacity: 1;
    transition-duration: ${(props) => props.$speed}ms;
  }
  &.fade-exit {
    opacity: 1;
  }
  &.fade-exit-active {
    opacity: 0;
    transition-duration: ${(props) => props.$speed}ms;
    transition-delay: 100ms;
  }
`;

interface LoadingTransitionProps {
  isLoading?: boolean;
  loading: React.ReactNode;
  content: React.ReactNode;
  speed?: number;
}

LoadingTransition.displayName = 'LoadingTransition';

export default LoadingTransition;
